<template>
	<el-config-provider :locale="locale">
		<router-view></router-view>
	</el-config-provider>
</template>

<script>
	import { defineComponent,onMounted } from "vue";
	import { ElConfigProvider } from "element-plus";
	import zhCn from "element-plus/lib/locale/lang/zh-cn";
	
	export default defineComponent({
	  components: {
	    ElConfigProvider,
	  },
	  setup() {
	    // 屏幕分辨率问题解决
	    // https://blog.csdn.net/Tsinbo1314/article/details/121860895
	    const bodyScale = () => {
	      var devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
	      var scale = devicewidth / 1920; // 分母——设计稿的尺寸
	      //document.body.style.zoom = scale; //放大缩小相应倍数
	    };
	    onMounted(() => {
	      bodyScale();
	    });
	    return {
	      locale: zhCn,
	    };
	  },
	});
</script>

<style>
	html,
	body {
		width: 100%;
		height: 100%;
	}

	#app {
		width: 100%;
		height: 100%;
	}

	/* 滚动条 */
	html::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	html::-webkit-scrollbar-thumb {
		background: #999999;
		border-radius: 20px;
	}

	body::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	body::-webkit-scrollbar-thumb {
		background: #999999;
		border-radius: 20px;
	}

	.scroll-view::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	.scroll-view::-webkit-scrollbar-thumb {
		background: #999999;
		border-radius: 20px;
	}
	
	.el-table {
	    .el-scrollbar__thumb {
	        background: #999999 !important;
	    }
	
	    .el-scrollbar__bar.is-horizontal {
	        height: 12px !important;
	    }
	
	    .el-scrollbar__bar.is-vertical {
	        width: 12px !important;
	    }
	}
</style>